import gql from "graphql-tag"
import { getClemanClientByClient } from '@/apis/cleman'
import { getCookie } from 'cookies-next'
import { VISITOR_ID_KEY } from '@/config/authing'

const graphqlUrl = gql`
mutation userBind($secondary: String!) {
  userBind(secondary: $secondary) {
    id
  }
}
`

/**
 * @description 学习记录合并（比如游客访问公开课程产生学习记录，然后登录后需要迁移记录到登录的账号）
 * @param visitorId 
 * @param token 
 */
const setUserBindByClient = async (visitorId?: string, token?: string) => {
  const secondary = visitorId || getCookie(VISITOR_ID_KEY)
  if (!secondary) return
  try {
    const client = getClemanClientByClient(token)
    const res = await client.apollo.mutate({
      mutation: graphqlUrl,
      variables: {
        secondary,
      },
    })
    return res
  } catch (error) {
    // $cookies.remove(VISITOR_ID_KEY)
    console.log(error)
  }
}

export { setUserBindByClient }